import { useState } from "react";
import { IoCheckmark, IoSaveOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import { saveAccountCompliancesAsync } from "../../../../../services/complianceService";
import Toaster from "./../../../../../components/common/Toaster";

const AccountCompliances = ({ id, data, isLoading, setLoading, onSuccess }) => {
  const [compliances, setCompliances] = useState(data);

  const handleChange = (item) => {
    const data = [...compliances];
    const index = data.indexOf(item);

    data[index] = { ...data[index] };
    data[index].is_compliance_active = !data[index].is_compliance_active;
    setCompliances(data);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      setLoading(true);
      await saveAccountCompliancesAsync(id, compliances);
      Toaster.Success("Account Compliances Updated Successfully");
      onSuccess();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-8 space-y-1">
      {compliances.map((item) => {
        return (
          <div
            key={item.id}
            onClick={() => handleChange(item)}
            className="card p-3 cursor-pointer hover:border-blue-400"
          >
            <div className="flex items-center justify-between">
              <p className="text-sm text-gray-400">{item.compliance_name}</p>
              {item.is_compliance_active && (
                <IoCheckmark className="text-green-500" />
              )}
            </div>
          </div>
        );
      })}
      <div className="grid grid-2 pt-5">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default AccountCompliances;
